export default "__VITE_ASSET__5gwckKbX__"